import { render, staticRenderFns } from "./CustomFormRecordView.vue?vue&type=template&id=7a485a53"
import script from "./CustomFormRecordView.js?vue&type=script&lang=js&external"
export * from "./CustomFormRecordView.js?vue&type=script&lang=js&external"
import style0 from "./CustomFormRecordView.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports